module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Italic.764c2cc5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Source_Sans_Pro/SourceSansPro-Italic.ttf
// module id = 78
// module chunks = 0